import router from '../router';
import ENV from '@/environment';
import i18n from '@/locales/i18n';
import {
  getContractPreview,
  mapUiLanguageToContractLanguage,
} from '@/services/contractService';

import { articles, articlesby } from '../components/articles';

const contractArticleMap = {
  contract: {
    contractType: 'Main',
    titleRu: 'Договор',
    title: 'Contract',
  },
  'vehicle-rental-contract': {
    contractType: 'Rent',
    titleRu: 'Договор аренды авто',
    title: 'Car rental Contract',
  },
  'user-agreement': {
    contractType: 'UserAgreement',
    titleRu: 'Пользовательское соглашение',
    title: 'User Agreement',
  },
  'privacy-policy': {
    contractType: 'PrivacyPolicy',
    titleRu: 'Политика в отношении обработки персональных данных',
    title: 'Privacy Policy',
  },
};

// В BY через contract-frontend отдаются только Договор, Пользовательское
// соглашение и Согласие на рекламу; остальные документы остаются статикой.
const contractArticleMapBy = {
  contract: {
    contractType: 'Main',
    titleRu: 'Договор',
    title: 'Contract',
  },
  'user-agreement': {
    contractType: 'UserAgreement',
    titleRu: 'Пользовательское соглашение',
    title: 'User Agreement',
  },
  'marketing-agreement': {
    contractType: 'MarketingAgreement',
    titleRu:
      'Согласие на получение сообщений рекламного и информационного характера',
    title: 'Marketing Agreement',
  },
};

export default {
  namespaced: true,

  state: {
    apiUrl: ENV.APP_API_HOST,
    articlesLoaded: false,
    articleLoaded: false,
    articles: ENV.REGION === 'by' ? articlesby : articles,
    articlesRules: {},
    article: {},
  },
  mutations: {
    articlesLoaded(state) {
      state.articlesLoaded = true;
    },
    articleLoaded(state, payload) {
      state.articleLoaded = true;
      state.article = payload;
    },
  },
  actions: {
    async loadArticle({ commit, state }, params) {
      const contractArticle =
        ENV.REGION === 'by'
          ? contractArticleMapBy[params.id]
          : contractArticleMap[params.id];

      if (!contractArticle) {
        commit(
          'articleLoaded',
          state.articles.find((article) => article.id === params.id),
        );
        return;
      }

      const response = await getContractPreview(
        contractArticle.contractType,
        mapUiLanguageToContractLanguage(i18n.locale),
      );

      if (!response.data) {
        await router.push('Home');
        return;
      }

      const _adapter = {
        doc: URL.createObjectURL(response.data),
        titleRu: contractArticle.titleRu,
        title: contractArticle.title,
      };
      commit('articleLoaded', _adapter);
    },
  },
};
